import { Pipe, PipeTransform } from '@angular/core';
import { getRiskAssessmentLabel } from '../../constants/doc-options.constants';

@Pipe({ name: 'riskAssessment', standalone: true })
export class RiskAssessmentPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return getRiskAssessmentLabel(value);
  }
}